import { render } from "./TourDetails.vue?vue&type=template&id=1f41e408&scoped=true"
import script from "./TourDetails.vue?vue&type=script&lang=js"
export * from "./TourDetails.vue?vue&type=script&lang=js"

import "./TourDetails.vue?vue&type=style&index=0&id=1f41e408&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f41e408"]])

export default __exports__